import * as Immutable from 'immutable';
import {
  LIST_IMPORTZIPS_REQUESTED,
  LIST_IMPORTZIPS_COMPLETED,
  LIST_IMPORTZIPS_FAILED,
} from '../../actions/imports/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_IMPORTZIPS_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case LIST_IMPORTZIPS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case LIST_IMPORTZIPS_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
